const config = {
  url: process.env.REACT_APP_IPFS_URL || 'http://localhost:8080/ipfs/'
}

export default config
